import { dataInfo } from '@BUP/constants'
import ProgressComponent from './progressComponent'

// TODO: ? is form code missing AO10

const PercentageProgressCard = ({ studentData }) => {
  const { surveyTotalData, totalAnswers } = studentData

  if (!surveyTotalData || !totalAnswers) return null

  const totalStudent = surveyTotalData.settings.enivel
  const studentResponses = totalAnswers.enivel

  const startwithEnivel = Object.prototype.hasOwnProperty.call(studentData.totalAnswers, 'enivel')

  const getResponseCode = (nivel, code, studentResponses) => {
    if (nivel === '3º' && studentResponses?.AO10 !== undefined) {
      return 'AO10'
    }
    return code
  }
  const percentagesByNivel = dataInfo.map(({ code, nivel }) => {
    if (!startwithEnivel) {
      return { value: 0, nivel, code }
    }

    const responseCodeTotal = getResponseCode(nivel, code, studentResponses)
    const responseCodeMin = getResponseCode(nivel, code, totalStudent)

    const responses = studentResponses?.[responseCodeTotal] || 0
    const min = totalStudent?.[responseCodeMin]?.min || 0
    const value = min ? Math.round((responses / min) * 100) : 0

    return {
      value,
      nivel,
      code: responseCodeTotal,
      totalResponses: responses
    }
  })

  const calculateTotalprogress = Math.round(
    (totalAnswers.total / surveyTotalData.settings.min) * 100
  )
  return (
    <ProgressComponent
      percentagesByNivel={percentagesByNivel}
      calculateTotalprogress={calculateTotalprogress}
    />
  )
}

export default PercentageProgressCard
